let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fP0v9")).then(() => parcelRequire('f29Su'));